/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSetting_2 } from '../fn/alert-notification-setting/add-setting-2';
import { AddSetting_2$Params } from '../fn/alert-notification-setting/add-setting-2';
import { AlertNotificationSetting } from '../models/alert-notification-setting';
import { deleteSetting_2 } from '../fn/alert-notification-setting/delete-setting-2';
import { DeleteSetting_2$Params } from '../fn/alert-notification-setting/delete-setting-2';
import { findByRoleId } from '../fn/alert-notification-setting/find-by-role-id';
import { FindByRoleId$Params } from '../fn/alert-notification-setting/find-by-role-id';
import { findByRoleName_1 } from '../fn/alert-notification-setting/find-by-role-name-1';
import { FindByRoleName_1$Params } from '../fn/alert-notification-setting/find-by-role-name-1';
import { findByTitle } from '../fn/alert-notification-setting/find-by-title';
import { FindByTitle$Params } from '../fn/alert-notification-setting/find-by-title';
import { getList_2 } from '../fn/alert-notification-setting/get-list-2';
import { GetList_2$Params } from '../fn/alert-notification-setting/get-list-2';
import { getSetting_3 } from '../fn/alert-notification-setting/get-setting-3';
import { GetSetting_3$Params } from '../fn/alert-notification-setting/get-setting-3';
import { getSettingsByTitleRoleId_1 } from '../fn/alert-notification-setting/get-settings-by-title-role-id-1';
import { GetSettingsByTitleRoleId_1$Params } from '../fn/alert-notification-setting/get-settings-by-title-role-id-1';
import { getSettingsByTitleRoleName } from '../fn/alert-notification-setting/get-settings-by-title-role-name';
import { GetSettingsByTitleRoleName$Params } from '../fn/alert-notification-setting/get-settings-by-title-role-name';
import { updateSetting_4 } from '../fn/alert-notification-setting/update-setting-4';
import { UpdateSetting_4$Params } from '../fn/alert-notification-setting/update-setting-4';

@Injectable({ providedIn: 'root' })
export class AlertNotificationSettingService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getList_2()` */
  static readonly GetList_2Path = '/api/notification/alert/setting';

  /**
   * Get List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_2$Response(params?: GetList_2$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
    return getList_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_2(params?: GetList_2$Params, context?: HttpContext): Observable<Array<AlertNotificationSetting>> {
    return this.getList_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AlertNotificationSetting>>): Array<AlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `addSetting_2()` */
  static readonly AddSetting_2Path = '/api/notification/alert/setting';

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSetting_2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_2$Response(params: AddSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return addSetting_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSetting_2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_2(params: AddSetting_2$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.addSetting_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `getSetting_3()` */
  static readonly GetSetting_3Path = '/api/notification/alert/setting/id/{settingId}';

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetting_3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_3$Response(params: GetSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return getSetting_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetting_3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_3(params: GetSetting_3$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.getSetting_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `findByRoleId()` */
  static readonly FindByRoleIdPath = '/api/notification/alert/setting/roleId/{roleId}';

  /**
   * Find By Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByRoleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleId$Response(params: FindByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
    return findByRoleId(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByRoleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleId(params: FindByRoleId$Params, context?: HttpContext): Observable<Array<AlertNotificationSetting>> {
    return this.findByRoleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AlertNotificationSetting>>): Array<AlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `findByRoleName_1()` */
  static readonly FindByRoleName_1Path = '/api/notification/alert/setting/roleName/{roleName}';

  /**
   * Find By Role Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByRoleName_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleName_1$Response(params: FindByRoleName_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
    return findByRoleName_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Role Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByRoleName_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleName_1(params: FindByRoleName_1$Params, context?: HttpContext): Observable<Array<AlertNotificationSetting>> {
    return this.findByRoleName_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AlertNotificationSetting>>): Array<AlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `findByTitle()` */
  static readonly FindByTitlePath = '/api/notification/alert/setting/title/{title}';

  /**
   * Find By Title.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByTitle$Response(params: FindByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
    return findByTitle(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Title.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByTitle(params: FindByTitle$Params, context?: HttpContext): Observable<Array<AlertNotificationSetting>> {
    return this.findByTitle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AlertNotificationSetting>>): Array<AlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `getSettingsByTitleRoleId_1()` */
  static readonly GetSettingsByTitleRoleId_1Path = '/api/notification/alert/setting/title/{title}/roleId/{roleId}';

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettingsByTitleRoleId_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId_1$Response(params: GetSettingsByTitleRoleId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return getSettingsByTitleRoleId_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettingsByTitleRoleId_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId_1(params: GetSettingsByTitleRoleId_1$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.getSettingsByTitleRoleId_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `getSettingsByTitleRoleName()` */
  static readonly GetSettingsByTitleRoleNamePath = '/api/notification/alert/setting/title/{title}/roleName/{roleName}';

  /**
   * Get Settings By Title Role Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettingsByTitleRoleName()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleName$Response(params: GetSettingsByTitleRoleName$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return getSettingsByTitleRoleName(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Settings By Title Role Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettingsByTitleRoleName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleName(params: GetSettingsByTitleRoleName$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.getSettingsByTitleRoleName$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `updateSetting_4()` */
  static readonly UpdateSetting_4Path = '/api/notification/alert/setting/{settingId}';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting_4()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_4$Response(params: UpdateSetting_4$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return updateSetting_4(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting_4$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_4(params: UpdateSetting_4$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.updateSetting_4$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `deleteSetting_2()` */
  static readonly DeleteSetting_2Path = '/api/notification/alert/setting/{settingId}';

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetting_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_2$Response(params: DeleteSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
    return deleteSetting_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetting_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_2(params: DeleteSetting_2$Params, context?: HttpContext): Observable<AlertNotificationSetting> {
    return this.deleteSetting_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertNotificationSetting>): AlertNotificationSetting => r.body)
    );
  }

}
